export const formatDegrees = (degrees) =>
  degrees.reduce((previous, current, index) => {
    if (index + 1 < degrees.length) return `${previous}${current}, `;
    return `${previous}${current}`;
  }, ', ');
